import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['details'];

  toggle() {
    this.detailsTarget.classList.toggle('d-none');
  }
}
